import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actions from "../actions";
import { Table, Input, Row, Col, message, Spin, notification } from "antd";
import {
  uniqueArray,
  extractKeyFromArray,
  getSearch,
  setSearch,
  getSorter,
  setSorter,
  setBranchFilter,
  getBranchFilter,
} from "lib/helper";
import {
  ImportExportBtn,
  AddBtn,
  ListAction,
  DeleteListModal,
  DeleteBadge,
  PageTitle,
} from "lib/widget";

import BranchSelect from "../../BranchSelect";

const Search = Input.Search;

class BranchHasCategoryList extends Component {

  static getDerivedStateFromProps(nextProps, prevState) {
    const { alertMessage, errorMessage } = nextProps.branchCategories;
    if (alertMessage !== "") {
      return { alertMessage: alertMessage };
    }

    if (errorMessage !== "") {
      return { errorMessage: errorMessage };
    }

    return null;
  }

  state = {
    page: 1,
    limit: 20,
    sorter: null,
    removeData: [],
    visible: false,
    visibleDelete: false,
    file: null,
    fileList: [],
    visibleImport: false,
    uploading: false,
    view: "table",
    branchId: null,
  };

  fetchData = () => {
    const { branchId, page, limit, keyword, sorter } = this.state;
    setSorter(sorter);
    setSearch(keyword);
    this.props.loadBranchCategories(branchId, page, limit, keyword, sorter);
  };

  onSearch(value) {
    this.setState({ keyword: value, page: 1 }, this.fetchData);
  }

  onChangePage = (pagination, filters, sorter) => {
    const { order, field } = sorter;
    const { current, pageSize } = pagination;
    this.setState(
      { page: current, limit: pageSize, sorter: { order, field } },
      this.fetchData
    );
  };

  handleChangeBranch = (value) => {
    setBranchFilter(value)
    if (value.length > 0) {
      this.setState({ branchId: value }, this.fetchData);
    } else {
      this.setState({ branchId: value });
    }
  };

  componentDidMount() {
    let branchId = getBranchFilter() !== null ? getBranchFilter() : [parseInt(localStorage.getItem("defaultBranchId"))]
    this.setState(
      {
        keyword: getSearch(),
        branchId: branchId,
        sorter: getSorter()
      },
      this.fetchData
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { alertMessage, errorMessage } = this.props.branchCategories;
    const prevMsg = prevProps.branchCategories;

    if (alertMessage !== "" && prevMsg.alertMessage !== alertMessage) {
      this.setState({ visibleImport: false });
      message.success(alertMessage);
    }

    if (errorMessage !== "" && prevMsg.errorMessage !== errorMessage) {
      this.openNotification(errorMessage);
    }
  }

  openNotification = (message) => {
    notification.error({
      message: "Import fail",
      description: message,
      duration: 0,
    });
  };

  showModalImport = () => {
    this.setState({
      visibleImport: true,
    });
  };

  handleCancel = () => {
    this.setState({ visibleImport: false });
  };

  onChooseFile = ({ file }) => {
    if (file.status !== "removed") {
      this.setState({ file, fileList: [file] });
    }
  };

  onRemove = () => this.setState({ fileList: [], file: null });

  handleUpload = () => {
    const { pagination, limit, keyword, file } = this.state;
    this.props.importBranchHasCategory(
      file,
      "branchHasCategory",
      pagination,
      limit,
      keyword,
      this.state.branchId
    );
    this.setState({ file: null, fileList: [] });
  };

  handleChangeView = (name) => {
    this.setState({ view: name });
  };

  handleDelete = (id, branchId) => () => {
    this.props.deleteBranchHasCategory(id, branchId);
  };

  handleDownLoad = () => {
    this.props.download(this.state.branchId);
  };

  onSelectChange = (selectedRowKeys) => {
    let items = selectedRowKeys;

    if (selectedRowKeys.length > 0) {
      let removeData = this.props.branchCategories.data.filter((x) =>
        selectedRowKeys.includes(x.branch_has_category_id)
      );

      let removeState = this.state.removeData.filter((x) =>
        selectedRowKeys.includes(x.branch_has_category_id)
      );
      items = uniqueArray(
        [...removeState, ...removeData],
        "branch_has_category_id"
      );
    }

    this.setState({ selectedRowKeys, removeData: items }, this.showDrawer);
  };

  handleDrawerClose = (name) => () => {
    this.setState({
      [name]: false,
    });
  };

  showDrawer = (name) => () => {
    this.setState({
      [name]: true,
    });
  };

  handleRemove = () => {
    this.props.destroyMany(
      extractKeyFromArray(this.state.removeData, "branch_has_category_id")
    );
    this.setState({
      selectedRowKeys: [],
      removeData: [],
      visibleDelete: false,
    });
  };

  handleRemoveAllItem = () => {
    this.setState({ selectedRowKeys: [], removeData: [] });
  };

  handleRemoveItem = (id) => {
    let item = this.state.selectedRowKeys.filter((x) => id !== x);
    let removeData = this.state.removeData.filter(
      (x) => x.branch_has_category_id !== id
    );
    this.setState({ selectedRowKeys: item, removeData });
  };

  render() {
    const { branchCategories } = this.props;
    const { selectedRowKeys, sorter } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };


    const actionCol = [
      {
        title: "",
        className: "column-action",
        width: window.innerWidth <= 500 ? 40 : 105,
        fixed: "left",
        render: (data) => (
          <ListAction
            editUrl={false}
            onDelete={this.handleDelete(data.product_category_id, data.branch_id)}
            id={data.product_category_id}
            name="branch_product_categories"
            breakpoint={500}
          />
        ),
      },
    ]

    const numberCol = [
      {
        title: "#",
        key: "index",
        className: "align-center",
        width: 50,
        render: (text, record, index) =>
          this.state.limit * (this.state.page - 1) + index + 1
      },
    ]

    const mainColumns = [
      {
        title: "Branch Name",
        width: 150,
        dataIndex: "branch_name",
      },
      {
        title: "Code",
        width: 150,
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'category_code' ? sorter.order : false,
        dataIndex: "category_code",
      },
      {
        title: "Name",
        sorter: true,
        sortOrder: sorter !== null && sorter.field === 'category_name' ? sorter.order : false,
        dataIndex: "category_name",
      }
    ];

    const columns = window.innerWidth <= 500 ? [...actionCol, ...mainColumns] : [...numberCol, ...mainColumns, ...actionCol]

    const display = this.state.view !== "table" ? "none" : "";
    let disabled = false;
    let disabledAdd = true;
    let source = branchCategories.data;
    let totalSize = this.props.branchCategories.totalSize;

    if (this.state.branchId !== null) {
      disabled = this.state.branchId.length === 0 ? true : false;
      disabledAdd = this.state.branchId.length === 1 ? false : true;

      if (this.state.branchId.length === 0) {
        source = [];
        totalSize = 0;
      }
    }

    const ActionComp = (
      <Fragment>
        <DeleteBadge
          count={this.state.removeData.length}
          onClick={this.showDrawer("visibleDelete")}
        />
        <Col xs={8} sm={8} md={8} lg={6}>
          {display === "" && (
            <ImportExportBtn
              disabledDownload={disabled}
              showModalImport={false}
              download={this.handleDownLoad}
              name="branch_product_categories"
            />
          )}
        </Col>
      </Fragment>
    );

    return (
      <div>
        <Spin size="large" spinning={this.props.branchCategories.loading}>
          <div style={{ marginBottom: 16 }}>
            <PageTitle
              name="branch_product_categories"
              component={
                <AddBtn
                  url={`/branch/categories/edit/${this.state.branchId}`}
                  name="branch_product_categories"
                  disabled={disabledAdd}
                />
              }
            />
            <Row gutter={[16, 16]}>
              {window.innerWidth > 500 && ActionComp}
              <Col xs={24} md={{ span: 8 }} sm={24} lg={{ span: 6, offset: 5 }}>
                <BranchSelect
                  branchId={this.state.branchId}
                  branches={this.props.branches}
                  onChange={this.handleChangeBranch}
                />
              </Col>
              {window.innerWidth > 500 &&
                <Col xs={24} sm={24} md={6} lg={6}>
                  <Search
                    defaultValue={getSearch()}
                    placeholder="Search for code or name"
                    onSearch={(value) => this.onSearch(value)}
                    style={{ width: "100%", display: display }}
                  />
                </Col>
              }
              {window.innerWidth <= 500 && (
                <Fragment>
                  {ActionComp}
                  <Col xs={13} sm={13} md={6} lg={6}>
                    <Search
                      defaultValue={getSearch()}
                      placeholder="Search for code or name"
                      onSearch={(value) => this.onSearch(value)}
                      style={{ width: "100%", display: display }}
                    />
                  </Col>
                </Fragment>
              )}
            </Row>
            <DeleteListModal
              onClose={this.handleDrawerClose}
              visible={this.state.visibleDelete}
              data={this.state.removeData}
              onRemove={this.handleRemove}
              removeItem={this.handleRemoveItem}
              removeAllItem={this.handleRemoveAllItem}
              displayKey={[
                "branch_has_category_id",
                "category_code",
                "category_name",
              ]}
            />
          </div>

          <Table
            rowKey={(record) => record.branch_has_category_id}
            columns={columns}
            rowSelection={rowSelection}
            bordered={true}
            size="small"
            dataSource={source}
            pagination={{
              pageSize: this.state.limit,
              total: totalSize,
              current: this.state.page,
            }}
            onChange={this.onChangePage}
            scroll={window.innerWidth <= 500 ? { x: 500 } : undefined}
          />
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = ({ branchCategories, branches }) => ({
  branchCategories,
  branches: branches.data,
});

const mapDispatchToProps = {
  loadBranchCategories: actions.loadBranchCategories.request,
  importBranchHasCategory: actions.importBranchHasCategory.request,
  download: actions.download.request,
  deleteBranchHasCategory: actions.deleteBranchHasCategory.request,
  destroyMany: actions.destroyMany.request,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BranchHasCategoryList);
